import React from 'react';
import styled from '@emotion/styled';
import { Shimmer } from '../../../../ui';
import { UserCurrentPoints } from './UserCurrentPoints';
import { useLoyaltyAccountStore } from '../../domain/stores/useLoyaltyAccountStore';
import { UserCurrentTier } from './UserCurrentTier';
import { SolidContentWrap } from '../../../shared/components';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { Section } from '../../../content-sections/ui/components/Section';
import CancelIcon from '../../../../../assets/icons/cancel.svg?reference';
import { StyledPointsProgressBar } from '../../../shared/components/progress-bar/ProgressBar';
import Responsive from '../../../../ui/utils/Responsive';

interface ICurrentTierPointsProps {
	store: ReturnType<typeof useLoyaltyAccountStore>;
}

export const CurrentTierPoints = ({ store }: ICurrentTierPointsProps) => {
	const { t } = useTranslation();
	const { isLoading, loyaltyDetails } = store;

	if (!loyaltyDetails && !isLoading) {
		return (
			<StyledSectionNoPadding>
				<StyledCurrentTierPoints>
					<StyledSolidContentWrap>
						<StyledFlexWrap>
							<img src={CancelIcon} alt="" />
							<strong>{t('loyalty_no_loyalty_details_label')}</strong>
						</StyledFlexWrap>
						<Shimmer>
							<StyledPointsProgressBar />
						</Shimmer>
						{t('general_error_message')}
					</StyledSolidContentWrap>
				</StyledCurrentTierPoints>
			</StyledSectionNoPadding>
		);
	}

	return (
		<StyledSectionNoPadding>
			<StyledCurrentTierPoints>
				<UserCurrentPoints data-testId="user-current-points" />
				<UserCurrentTier />
			</StyledCurrentTierPoints>
		</StyledSectionNoPadding>
	);
};

const StyledSectionNoPadding = styled(Section)`
	padding-top: 20px;
	padding-bottom: 20px;
`;

const StyledSolidContentWrap = styled(SolidContentWrap)`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

const StyledFlexWrap = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
`;

const StyledCurrentTierPoints = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 24px;

	> div {
		height: 9.5rem;
		margin: 0;
		border-radius: 8px;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: column;
		> div {
			height: 8.5rem;
		}
	}
`;
